import {
    MOBILITY_BICYCLING,
    MOBILITY_DRIVING,
    MOBILITY_TRANSIT,
    MOBILITY_TWO_WHEELER,
    RIDINGS_PER_WEEK_FLEXIBLE,
} from '../marketplace-custom-config';
import {
    HORSE_TYPE_FREIZEITPFERD,
    HORSE_TYPE_HORSE_KIND,
    HORSE_TYPE_JUNGPFERD_IN_AUSBILDUNG,
    HORSE_TYPE_SENIOR,
} from '../components/EditListingWizard/config';

export const transformHorseType = horseType => {
    switch (horseType) {
        case HORSE_TYPE_JUNGPFERD_IN_AUSBILDUNG:
            return 'Jungpferd in Ausbildung';

        case HORSE_TYPE_FREIZEITPFERD:
            return 'Freizeitpferd';

        case HORSE_TYPE_HORSE_KIND:
            return 'Sportpferd';

        case HORSE_TYPE_SENIOR:
            return 'Senior';
    }
    return undefined;
};

export const transformMobilityTransport = mobilityTransport => {
    switch (mobilityTransport) {
        case MOBILITY_TRANSIT:
            return 'Öffentliche Verkehrsmittel';
        case MOBILITY_BICYCLING:
            return 'Fahrrad';
        case MOBILITY_TWO_WHEELER:
            return 'Motorrad';
        case MOBILITY_DRIVING:
            return 'Auto';
    }
    return undefined;
};

export const transformAvailability = availability => {
    if (!availability) return undefined;
    return availability === RIDINGS_PER_WEEK_FLEXIBLE
        ? 'Flexibel'
        : `${availability} Tage pro Woche`;
};
